export default __webpack_public_path__ + "static/media/SpheroCentral_Logo_Color.ee5d17ca.svg";